import { Link } from "react-router-dom";
import {
  PhoneIcon,
  PrinterIcon,
  AtSymbolIcon,
  EnvelopeIcon,
} from "@heroicons/react/20/solid";

export default function Home() {
  return (
    <>
      <header className="relative w-full border-b border-b-black bg-gray-200">
        <section className="mx-auto flex max-w-[85rem] flex-row flex-wrap items-center justify-around gap-x-6 px-6 py-4 md:justify-center lg:justify-around ">
          <div className="grow-0 basis-5/12">
            <h2 className="pb-4 font-serif text-[110%] text-xl sm:text-2xl font-bold italic">
              Emergency Vehicle Technician Certification Commission, Inc.
            </h2>
          </div>
          <div className="grow-0 basis-6/12 lg:basis-auto">
            <div className="flex flex-wrap items-center justify-around gap-x-10 gap-y-4 lg:items-start">
              <div className="flex flex-col flex-nowrap space-y-3">
                <div className="flex items-center space-x-2">
                  <PhoneIcon className="size-5 text-(--darkred) md:size-6" />
                  <span className="whitespace-nowrap">(847) 426-4075</span>
                </div>
                <div className="flex items-center space-x-2">
                  <AtSymbolIcon className="size-5 text-(--darkred) md:size-6" />
                  <span>evtcert@evtcc.org</span>
                </div>
                <div className="flex items-center space-x-2">
                  <PrinterIcon className="size-5 text-(--darkred) md:size-6" />
                  <span className="whitespace-nowrap">(847) 426-4076</span>
                </div>
              </div>

              <div className="hidden space-x-2 lg:flex">
                <EnvelopeIcon className="size-5 text-(--darkred) md:size-6" />
                <div>
                  <div className="font-bold">EVTCC</div>
                  <div>P.O. Box 894</div>
                  <div>Dundee, IL 60118</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </header>
      <main className="mt-4 w-full">
        <div className="mx-auto grid max-w-[85rem] gap-x-12 gap-y-6 px-8 lg:grid-cols-3">
          <section>
            <h1 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              About EVTCC
            </h1>
            <p className="my-2 text-justify md:block">
              The EVT Certification Commission, Inc. is a nonprofit corporation
              dedicated to improving the quality of emergency vehicle service
              and repair throughout the United States and Canada by means of a
              certification program that will provide technicians recognition
              for the education, training, and experience they have in the
              upfitting, service, and repair of emergency vehicles.
            </p>
            <Link
              to="/about"
              className="my-2 text-(--themered) hover:text-(--darkred) hover:underline"
            >
              Learn more
            </Link>
          </section>
          <section>
            <h1 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Upcoming Testing
            </h1>
            <p className="my-2">Nationwide test dates are:</p>
            <ul className="list-disc pl-6">
              <li>Week of Saturday, May 17, 2025</li>
              <li>Week of Saturday, October 18, 2025</li>
            </ul>
            <p className="my-2">
              Additional testing is available at Mechanic and Manufacturer
              Training events.
            </p>
            <ul className="ml-6 list-disc">
              <li>
                <a
                  className="my-2 text-(--themered) hover:text-(--darkred) hover:underline"
                  href="/testing-events"
                >
                  See all testing events via our online portal
                </a>
              </li>
              <li>
                <a
                  className="my-2 text-(--themered) hover:text-(--darkred) hover:underline"
                  href="/downloads/EVTCC-Test-Site-List.pdf"
                >
                  Download a list of testing events
                </a>
              </li>
            </ul>
          </section>
          <section>
            <h1 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Registration
            </h1>
            <p className="my-2 text-justify">
              Online registration must be completed 16 days prior to testing.
              Save 10% by registering online.
            </p>
            <Link
              to="https://register.evtcc.org"
              className="my-2 block w-48 rounded-full border border-(--themered) p-2 px-4 text-center font-bold text-(--themered) hover:text-(--darkred) hover:border-(--darkred) hover:underline"
            >
              &#9733; Register Online
            </Link>
            <p className="my-2 mt-4 text-justify">
              Paper registration forms must be <em>received</em> (fax, mail, or
              email) 21 days prior to the test date.
            </p>
            <a
              href="/downloads/EVTCC-Exam-Registration.pdf"
              className="my-2 text-(--themered) hover:text-(--darkred) hover:underline"
            >
              Download the form
            </a>
          </section>
        </div>
      </main>
    </>
  );
}
